import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';
import { VendorTradeService } from 'src/app/services/vendor-trade.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-vendor-trades-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './vendor-trades-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorTradesGridComponent extends BaseGridComponent {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private VendorTradeService: VendorTradeService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'VendorTrade';
    this.rowModelType = 'serverSide';

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.VendorTradeService.getVendorTrades(queryObject),
          this.VendorTradeService.getVendorTradesCount(countQueryObject)
        ]).subscribe({
          next: ([VendorTrades, VendorTradesCount]) => {
            params.success({
              rowData: VendorTrades,
              rowCount: VendorTradesCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
